const prefix = 'medium';

export default {
    update: `${prefix}.update`,
    download: {
        started: `${prefix}.download.started`,
        progress: `${prefix}.download.progress`,
        finished: `${prefix}.download.finished`,
        failed: `${prefix}.download.failed`,
    },
};



// WEBPACK FOOTER //
// ./scripts/frontend/base/actions/Medium.js